import * as types from './mutation-types'

import { signIn, signOut } from '../utils/cookies'

import api from '../api'

export const setMobile = ({ commit }, value) => {
  commit(types.SET_MOBILE, value)
}

export const setNavbar = ({ commit }, value) => {
  commit(types.SET_NAVBAR, value)
}

export const showNotification = ({ commit }, notificationData) => {
  commit(types.SHOW_NOTIFICATION, notificationData)
}

export const nextNotification = ({ commit }) => {
  commit(types.UNLOCK_NOTIFICATION)
}

export const newEvent = ({ commit }, eventString) => {
  commit(types.ADD_EVENT, eventString)
  setTimeout(() => {
    commit(types.UNLOCK_EVENT)
  }, 10)
}

export const activateScroll = ({ commit }) => {
  commit(types.ACTIVATE_SCROLL)
}
export const deactivateScroll = ({ commit }) => {
  commit(types.DEACTIVATE_SCROLL)
}

export const nextEvent = ({ commit }) => {
  commit(types.UNLOCK_EVENT)
}

export const logout = ({dispatch, router}) => {
  signOut()
  dispatch(types.LOGOUT_USER)
  window.location.pathname = '/'
}

export const localLogin = ({ commit, state }, userInfo) => {
  commit(types.ADD_LOADING_BTN, '.btn-submit-login')

  api.localLogin(userInfo).then(response => {
    // if (!response.ok) {
    //   return showNotification(commit, {title: 'Authentication Error', message: response.data.error, type: 'danger'})
    // }
    signIn(response.data.token, userInfo.email)
    commit(types.LOGIN_SUCCESS, {token: response.data.token, email: response.data.email, admin: response.data.admin})

    let notificationData = {title: 'Autenticação', message: 'Login realizado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.btn-submit-login')

    let routeRedirect = window.router.currentRoute.query.redirect
    if (typeof routeRedirect === 'undefined') {
      window.router.push('/')
    } else {
      window.router.push(routeRedirect)
    }
  }, response => {
    let appError = null

    let jwtError = response.data.error
    switch (jwtError) {
      case 'invalid_credentials':
        appError = 'Par Email/Password Inválido.'
        break
    }

    let notificationData = {title: 'Autenticação', message: appError, type: 'danger'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.btn-submit-login')
  })
}

// COACH --------------------------------------------------------------------------------------------------------

export const getCoachList = ({ commit, state }) => {
  api.getCoachList().then(response => {
    commit(types.COACH_LIST, response.data)

    // let notificationData = {title: 'Coches', message: 'Lista de coches atualizada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coches', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const saveCoach = ({ commit, state }, coachInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.saveCoach(coachInfo).then(response => {
    let notificationData = {title: 'Coche', message: 'Novo Coche criado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getCoachList({ commit, state })
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const getCoach = ({ commit, state }, coachId) => {
  api.getCoach(coachId).then(response => {
    commit(types.GET_COACH_DATA, response.data.data.coach)

    // let notificationData = {title: 'Coche', message: 'Coche carregado com sucesso.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateCoach = ({ commit, state }, coachInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.updateCoach(coachInfo.id, coachInfo.data).then(response => {
    let notificationData = {title: 'Coche', message: 'Coche alterado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getCoach({ commit, state }, coachInfo.id)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const deleteCoach = ({ commit, state }, coachId) => {
  api.deleteCoach(coachId).then(response => {
    let notificationData = {title: 'Coche', message: 'Coche apagado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    window.store.dispatch('newEvent', 'update-coach-list')

    getCoachList({ commit, state })
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateCoachScreensaver = ({ commit, state }, data) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.updateCoachScreensaver(data).then(response => {
    let notificationData = {title: 'Coche', message: 'Screensaver alterado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getCoach({ commit, state }, data.id)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const updateCoachState = ({ commit, state }, data) => {
  api.updateCoachState(data).then(response => {
    let notificationData = {title: 'Coche', message: 'Estado do Coche alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getCoach({ commit, state }, data.id)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// MENU ---------------------------------------------------------------------------------------------------------

export const categoryCoach = ({ commit, state }, categoryInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.categoryCoach(categoryInfo).then(response => {
    let notificationData = {title: 'Menu', message: 'Menu alterado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getCategoryList({ commit, state }, categoryInfo.coach_id)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const categoryCoachUpdate = ({ commit, state }, categoryInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.categoryCoach(categoryInfo).then(response => {
    let notificationData = {title: 'Menu', message: 'Menu alterado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getCategoryList({ commit, state }, categoryInfo.coach_id)
    getSlideList({ commit, state }, {coach: categoryInfo.coach_id, category: categoryInfo.slide_category_id})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const updateCategoryCoachState = ({ commit, state }, data) => {
  api.updateCategoryCoachState(data).then(response => {
    let notificationData = {title: 'Menu', message: 'Estado do Menu alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getCategoryList({ commit, state }, data.data.coach)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const categoryCoachRemove = ({ commit, state }, categoryInfo) => {
  api.categoryCoachRemove(categoryInfo).then(response => {
    let notificationData = {title: 'Menu', message: 'Menu removido com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    window.store.dispatch('newEvent', 'update-category-list')
    getCategoryList({ commit, state }, categoryInfo.coach_id)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const getCategoryList = ({ commit, state }, coachId) => {
  api.getCategoryList(coachId).then(response => {
    commit(types.MENU_LIST, response.data)

    // let notificationData = {title: 'Menu', message: 'Lista de Menus do Coche atualizada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Menu', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateMenuState = ({ commit, state }, data) => {
  api.updateCategoryCoachState(data).then(response => {
    let notificationData = {title: 'Menu', message: 'Estado do Menu alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getSlideList({ commit, state }, {coach: data.data.coach, category: data.data.category})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Coche', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// SLIDE --------------------------------------------------------------------------------------------------------

export const getSlideList = ({ commit, state }, menuData) => {
  api.getSlideList(menuData).then(response => {
    commit(types.SLIDE_LIST, response.data)

    // let notificationData = {title: 'Menu', message: 'Lista de slides atualizada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Menu', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const saveSlide = ({ commit, state }, slideInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.saveSlide(slideInfo).then(response => {
    let notificationData = {title: 'Slide', message: 'Slide criado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: response.data.data.slide.coach_id, category: response.data.data.slide.slide_category_id})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const updateSlide = ({ commit, state }, slideInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.updateSlide(slideInfo.id, slideInfo.slide).then(response => {
    let notificationData = {title: 'Slide', message: 'Slide alterado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: slideInfo.slide.coach_id, category: slideInfo.slide.slide_category_id})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const deleteSlide = ({ commit, state }, id) => {
  api.deleteSlide(id).then(response => {
    let notificationData = {title: 'Slide', message: 'Slide apagado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: response.data.data.slide.coach_id, category: response.data.data.slide.slide_category_id})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const reorderSlides = ({ commit, state }, data) => {
  api.reorderSlides(data).then(response => {
    // let notificationData = {title: 'Slides', message: 'Lista de slide reordenada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)

    getSlideList({ commit, state }, {coach: data.slide.coach_id, category: data.slide.slide_category_id})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Slides', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateSlideState = ({ commit, state }, data) => {
  api.updateSlideState(data).then(response => {
    let notificationData = {title: 'Slide', message: 'Estado do Slide alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getSlideList({ commit, state }, {coach: data.data.coach, category: data.data.category})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// SUB SLIDE ----------------------------------------------------------------------------------------------------

export const setSubSlideCategory = ({ commit, state }, data) => {
  api.setSubSlideCategory(data).then(response => {
    let notificationData = {title: 'Sub-Slide', message: 'Defenido novo set de sub-slides.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: data.coach, category: data.menu})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Sub-Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const deleteSubMenu = ({ commit, state }, data) => {
  api.deleteSubSlideCategory(data.id).then(response => {
    let notificationData = {title: 'Sub-Slide', message: 'Set de sub-slides apagado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: data.coach, category: data.menu})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Sub-Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateSubSlideCategory = ({ commit, state }, data) => {
  api.updateSubSlideCategory(data).then(response => {
    let notificationData = {title: 'Sub-Slide', message: 'Set de sub-slides alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    window.store.dispatch('newEvent', 'modal-card-close')
    getSlideList({ commit, state }, {coach: data.coach, category: data.menu})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Sub-Slide', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// PANORAMA -----------------------------------------------------------------------------------------------------

export const getPanorama = ({ commit, state }, coachId) => {
  api.getPanorama(coachId).then(response => {
    commit(types.GET_PANORAMA_DATA, response.data.data.panorama)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Panorama', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updatePanorama = ({ commit, state }, panoramaData) => {
  api.updatePanorama(panoramaData.panoramaId, panoramaData).then(response => {
    let notificationData = {title: 'Panorama', message: 'Panorama atualizado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Panorama', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const savePanoramaPoint = ({ commit, state }, pointData) => {
  api.savePanoramaPoint(pointData).then(response => {
    commit(types.GET_PANORAMA_DATA, response.data.data.panorama)

    let notificationData = {title: 'Hotspot', message: 'Hotspot guardado com sucesso.', type: 'success'}

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    commit(types.SHOW_NOTIFICATION, notificationData)
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Hotspot', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updatePanoramaPoint = ({ commit, state }, pointData) => {
  api.updatePanoramaPoint(pointData.pointId, pointData).then(response => {
    commit(types.GET_PANORAMA_DATA, response.data.data.panorama)
    let notificationData = {title: 'Hotspot', message: 'Hotspot alterado com sucesso.', type: 'success'}

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    commit(types.SHOW_NOTIFICATION, notificationData)
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Hotspot', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const deletePanoramaPoint = ({ commit, state }, pointId) => {
  api.deletePanoramaPoint(pointId).then(response => {
    commit(types.GET_PANORAMA_DATA, response.data.data.panorama)

    let notificationData = {title: 'Hotspot', message: 'Hotspot apagado com sucesso.', type: 'success'}

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    commit(types.SHOW_NOTIFICATION, notificationData)
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Hotspot', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const deletePanoramaCube = ({ commit, state }, cubeData) => {
  api.deletePanoramaCube(cubeData.panoramaId, cubeData.position).then(response => {
    commit(types.GET_PANORAMA_DATA, response.data.data.panorama)

    let notificationData = {title: 'Face', message: 'Face apagada com sucesso.', type: 'success'}

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    commit(types.SHOW_NOTIFICATION, notificationData)
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Face', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// EXTERIOR -----------------------------------------------------------------------------------------------------

export const getExteriorsList = ({ commit, state }, coachData) => {
  api.getExteriorsList(coachData.coachId, coachData).then(response => {
    commit(types.GET_EXTERIOR_DATA, response.data.data.exteriors)

    // let notificationData = {title: 'Exterior', message: 'Lista de exteriores atualizada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const reorderExteriors = ({ commit, state }, data) => {
  api.reorderExteriors(data).then(response => {
    getExteriorsList({ commit, state }, {coachId: data.coach})
  }, response => {
    if (response.data) {
      // let jwtError = response.data.error
      // let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      // commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateExteriorState = ({ commit, state }, data) => {
  api.updateExteriorState(data).then(response => {
    let notificationData = {title: 'Exterior', message: 'Estado do Slide Exterior alterado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getExteriorsList({ commit, state }, {coachId: data.data.coach})
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const saveExterior = ({ commit, state }, data) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.saveExterior(data).then(response => {
    let notificationData = {title: 'Exterior', message: 'Slide Exterior guardado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getExteriorsList({ commit, state }, {coachId: data.coach})

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const updateExterior = ({ commit, state }, data) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.updateExterior(data.exteriorId, data).then(response => {
    let notificationData = {title: 'Exterior', message: 'Slide Exterior guardado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getExteriorsList({ commit, state }, {coachId: data.coach})

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const deleteExterior = ({ commit, state }, data) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')
  api.deleteExterior(data.exteriorId).then(response => {
    let notificationData = {title: 'Exterior', message: 'Slide Exterior apagado.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    getExteriorsList({ commit, state }, {coachId: data.coachId})

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Exterior', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

// USER ---------------------------------------------------------------------------------------------------------

export const getUserList = ({ commit, state }) => {
  api.getUserList().then(response => {
    commit(types.USER_LIST, response.data)

    // let notificationData = {title: 'Utilizadores', message: 'Lista de utilizadores atualizada.', type: 'success'}
    // commit(types.SHOW_NOTIFICATION, notificationData)
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Utilizadores', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
    }
  })
}

export const deleteUser = ({ commit, state }, userId) => {
  api.deleteUser(userId).then(response => {
    commit(types.USER_LIST, response.data)

    let notificationData = {title: 'Utilizadores', message: 'Utilizador apagado', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    commit(types.USER_LIST, response.data)

    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Utilizadores', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const updateUser = ({ commit, state }, userInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.updateUser(userInfo.id, userInfo).then(response => {
    let notificationData = {title: 'Utilizador', message: 'Utilizador editado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    commit(types.USER_LIST, response.data)

    window.store.dispatch('newEvent', 'modal-card-close')
    window.store.dispatch('getUserList')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Utilizador', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)
      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}

export const saveUser = ({ commit, state }, userInfo) => {
  commit(types.ADD_LOADING_BTN, '.card-modal-ok-btn')

  api.saveUser(userInfo).then(response => {
    let notificationData = {title: 'Utilizador', message: 'Utilizador criado com sucesso.', type: 'success'}
    commit(types.SHOW_NOTIFICATION, notificationData)

    commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')

    commit(types.USER_LIST, response.data)

    window.store.dispatch('newEvent', 'modal-card-close')
  }, response => {
    if (response.data) {
      let jwtError = response.data.error
      let notificationData = {title: 'Utilizador', message: jwtError, type: 'danger'}
      commit(types.SHOW_NOTIFICATION, notificationData)

      commit(types.REMOVE_LOADING_BTN, '.card-modal-ok-btn')
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js